import { useAlarms } from '@hakimo-ui/hakimo/data-access';
import { Alarm, AlarmListFilters } from '@hakimo-ui/hakimo/types';
import { LoadingIndicator } from '@hakimo-ui/hakimo/ui-elements';
import { Alert } from '@hakimo-ui/shared/ui-base';
import { ReactElement } from 'react';
import { useSearchParams } from './list-view/useSearchParams';

export interface Props {
  page: number;
  pageSize: number;
  filters: AlarmListFilters;
  onCount: (count: number) => void;
  children: (alarms: Alarm[]) => ReactElement;
}

export function LocationAlarmsData(props: Props) {
  const { page, pageSize, filters, onCount, children } = props;
  const [initalizing, searchParams] = useSearchParams(page, pageSize, filters);

  const { isError, error, data } = useAlarms(
    searchParams,
    0,
    ({ total }) => {
      onCount(total);
    },
    initalizing,
    true
  );

  if (initalizing) {
    return <LoadingIndicator />;
  }

  if (isError) {
    return <Alert>{error.message}</Alert>;
  }

  return children(data?.items ?? []);
}

export default LocationAlarmsData;
